import { Component, ViewEncapsulation, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { isArray } from 'util';

@Component({
  selector: 'app-page-form',
  templateUrl: 'page-form.component.html',
  styleUrls: ['page-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class PageFormComponent implements OnChanges {
  @Input() pageData: any = null;

  @Output() clickNewSectionCreate = new EventEmitter<any>();
  @Output() clickDeleteSection = new EventEmitter<any>();

  public editPageData: any = new Object();

  /**
   * Creates an instance of PageFormComponent.
   * @memberof PageFormComponent
   */
  constructor(
  ) { }

  /**
   * データ変更時処理
   *
   * @param {SimpleChanges} changes
   * @memberof PageFormComponent
   */
  ngOnChanges(changes: SimpleChanges): void {
    Object.keys(changes).forEach((propName) => {
      switch (propName) {
        case 'pageData':
          this.editPageData = changes.pageData.currentValue;

          Object.keys(this.editPageData).forEach(key => {
            if (isArray(this.editPageData[key])) {
              this.editPageData[key] = this.editPageData[key][0];
            } else {
              this.editPageData[key] = this.editPageData[key];
            }
            // 分割数を数値型に変換(WjInputNumberの値に文字列を設定するとエラーとなるため)
            if (key === 'DivH' || key === 'DivW') {
              this.editPageData[key] = Number(this.editPageData[key]);
            }
          });
      }
    });
  }
}
